import React from "react";
import { ClockIcon } from "lucide-react";
import { useCountdown } from "../hooks/useCountdown";
type CountdownProps = {
  dark?: boolean;
  note?: string;
};
export function Countdown({
  dark = false,
  note
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: "Hours"
  }, {
    value: minutes,
    label: "Min"
  }, {
    value: seconds,
    label: "Sec"
  }];
  return <div className="flex flex-col items-center" role="timer" aria-live="off" data-id="element-46" data-mp="3c0b59scgi1ue">
      <p className={`flex items-center gap-2 text-center text-xs font-bold uppercase tracking-wider sm:text-sm ${dark ? "text-gold" : "text-danger"}`} data-id="element-47" data-mp="3h20h3a7i6jjj">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-48" data-mp="3262r69o6abfr" />
        The special launch offer ends in:
      </p>
      <div className="mt-3 flex items-start gap-2" data-id="element-49" data-mp="10cbqtanm4pbm">
        {units.map((u, i) => <React.Fragment key={u.label} data-id="element-50" data-mp="10aimi20h2h6s" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-51" data-mp="15bochs2qzqcm">
              <span className={`flex h-16 w-[72px] items-center justify-center rounded-xl font-serif text-4xl font-black tabular-nums sm:h-20 sm:w-20 sm:text-5xl ${dark ? "bg-white text-ink" : "bg-ink text-white"}`} data-id="element-52" data-mp="15928g2f2fsz5">
                {u.value}
              </span>
              <span className={`mt-1.5 text-[11px] font-semibold uppercase tracking-wider ${dark ? "text-white/60" : "text-ink/55"}`} data-id="element-53" data-mp="17qgekuck9wgx">{u.label}</span>
            </div>
            {i < units.length - 1 && <span className={`pt-4 font-serif text-3xl font-black ${dark ? "text-white/60" : "text-ink/40"}`} data-id="element-54" data-mp="f33selabbqo5">:</span>}
          </React.Fragment>)}
      </div>
      {note && <p className={`mt-3 max-w-sm text-center text-sm ${dark ? "text-white/70" : "text-ink/65"}`} data-id="element-55" data-mp="o38z0t7oml19">{note}</p>}
    </div>;
}